module.exports = __webpack_public_path__ + "media/images/ac-supplier-2-0d1574fff44c283a1a308c89e8da77d3.jpg";